// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__e5fSt","title":"ClientInsurance_title__1A7F5","itemText":"ClientInsurance_itemText__OXS9X"};